module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.showMovieAdder) ? _c('div', {
    staticClass: "seating"
  }, [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dialogMsg)
    }
  }), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDialog = false;
      }
    }
  }, [_vm._v("Ok")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.seatingDialog),
      callback: function($$v) {
        _vm.seatingDialog = $$v
      },
      expression: "seatingDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seatingDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seatingDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("You've selected the maximum number of seats per single transaction. Should you wish to book more seats, please note you will have to make a separate transaction. Alternatively you can contact us on 0861 MOVIES (668437) and select Option 3 to book more than 19 seats in one transaction")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.seatingDialog = false
      }
    }
  }, [_vm._v("Got it")])], 1), _vm._v(" "), _c('div', {
    staticClass: "covid-message"
  }, [_c('sk-layout', {
    staticClass: "covid-wrapper",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    staticClass: "covid-panel"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "covid-icon-container",
    attrs: {
      "lg1": "",
      "md2": "",
      "sm2": "",
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "icon icon-combo"
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "covid-message-container",
    attrs: {
      "lg11": "",
      "md10": "",
      "sm10": "",
      "xs9": ""
    }
  }, [_c('p', [_vm._v("\n                                Reminder: You can order your snacks online after you have selected your seat or order them in cinema\n                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), (_vm.floodLightShow) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.floodlightPixel) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('sk-panel', [_c('h2', [_vm._v("Choose Your Seats")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.cinema_name) + " - " + _vm._s(_vm.screen_name))]), _vm._v(" "), (_vm.loading || (_vm.order && _vm.order.loading === true)) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "seat_grid"
  }, [_c('p', {
    staticClass: "seating__screen seating__screen--top"
  }, [_vm._v("\n                    Screen\n                    "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/screen.png",
      "alt": "screen"
    }
  })]), _vm._v(" "), (_vm.order && _vm.order.Session && !_vm.loading && (_vm.order && !_vm.order.loading)) ? [_c('sk-seat-grid', {
    attrs: {
      "validate-changefn": _vm.selectable,
      "seat-grid": _vm.order.Session.SeatGrid.grid
    },
    on: {
      "seatChange": _vm.setSeat
    }
  })] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "seating__screen seating__screen--bottom"
  }, [_vm._v("\n                    Back of Cinema\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "seat-plan"
  }, [_c('p', [_vm._v("Seating Key")]), _vm._v(" "), _c('sk-list', {
    staticClass: "seat-grid",
    attrs: {
      "inline": ""
    }
  }, [_c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "selected": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Selected")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Available")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "sold": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Sold")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "love-nest": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Love nest")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "wheelchair": "",
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Wheelchair")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "companion": "",
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Companion")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "dbox": "",
      "available": "",
      "empty": true
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("DBox")])], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-seat', {
    attrs: {
      "kids": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "seat-plan--label"
  }, [_vm._v("Kid's seat")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "seating__content"
  }, [_vm._v("You've chosen " + _vm._s(_vm.order.Tickets.length) + " seat"), (_vm.order.Tickets.length != 1) ? [_vm._v("s")] : _vm._e()], 2)], 2)]), _vm._v(" "), (_vm.order && !_vm.loading && (_vm.order && !_vm.order.loading)) ? _c('sk-panel', [(_vm.order) ? _c('sk-loyalty', {
    attrs: {
      "order": _vm.order
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-layout', {
    staticClass: "seating__btns",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.$breakpoints.smDown) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": true,
      "block": _vm.$breakpoints.smDown,
      "loading": _vm.loadingAnotherMovie
    },
    nativeOn: {
      "click": function($event) {
        _vm.showAddMovieForm()
      }
    }
  }, [_vm._v("Add\n                    Another Movie\n                ")]), _vm._v(" "), (_vm.fanLoyaltyCountAdded > 0 || _vm.morviesLoyaltyCountAdded > 0) ? [_c('sk-button', {
    attrs: {
      "primary": true,
      "block": _vm.$breakpoints.smDown,
      "loading": _vm.updateOrderLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.subsComboDialog = true
      }
    }
  }, [_vm._v("Continue OR Add Extras\n                    ")])] : [_c('sk-button', {
    attrs: {
      "primary": true,
      "block": _vm.$breakpoints.smDown,
      "loading": _vm.updateOrderLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateOrder()
      }
    }
  }, [_vm._v("Continue OR Add Extras\n                    ")])]], 2)], 1) : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.subsComboDialog),
      callback: function($$v) {
        _vm.subsComboDialog = $$v
      },
      expression: "subsComboDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.subsComboDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.subsComboDialog = false
      }
    }
  }), _vm._v(" "), (_vm.morviesLoyaltyCountAdded > 0) ? _c('h3', [_vm._v("Subscription Club Combo")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Your subscription club combo has been successfully added to this booking.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.subsComboDialog = false;
        _vm.updateOrder();
      }
    }
  }, [_vm._v("\n                Okay\n            ")])], 1), _vm._v(" "), [(_vm.facebookPixelSKShow) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "src": "https://www.facebook.com/tr?id=700460340621505&ev=PageView&noscript=1"
    }
  }) : _vm._e()]], 2)], 1) : _c('div', {
    staticClass: "addMovie detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "detail-cinema"
  }, [(_vm.festival) ? _c('h2', {
    staticClass: "detail-start-booking"
  }, [_vm._v("Add another " + _vm._s(_vm.festival.title) + " movie")]) : _c('h2', {
    staticClass: "detail-start-booking"
  }, [_vm._v("Add another movie")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('label', [_vm._v("Choose a Movie at " + _vm._s(_vm.currentCinema))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.festival) ? [(_vm.moviesGrouped[0].movies.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.moviesGrouped,
      "group-values": "movies",
      "group-label": "name",
      "track-by": "name",
      "label": "name",
      "searchable": true,
      "placeholder": "Choose a movie"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                            " + _vm._s(props.option.$groupLabel) + "\n                                        ")] : _c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": props.option.poster
          }
        })]), _vm._v("\n                                                " + _vm._s(props.option.title) + "\n                                        ")])]
      }
    }]),
    model: {
      value: (_vm.selectedMovie),
      callback: function($$v) {
        _vm.selectedMovie = $$v
      },
      expression: "selectedMovie"
    }
  }) : _c('p', [_vm._v("There are no available movies to add to the booking.")])] : [(_vm.moviesGrouped.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.moviesGrouped,
      "group-values": "movies",
      "group-label": "name",
      "track-by": "name",
      "label": "name",
      "searchable": true,
      "placeholder": "Choose a movie"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                            " + _vm._s(props.option.$groupLabel) + "\n                                        ")] : _c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": props.option.poster
          }
        })]), _vm._v("\n                                                " + _vm._s(props.option.title) + "\n                                        ")])]
      }
    }]),
    model: {
      value: (_vm.selectedMovie),
      callback: function($$v) {
        _vm.selectedMovie = $$v
      },
      expression: "selectedMovie"
    }
  }) : _c('sk-combo-select', {
    attrs: {
      "options": _vm.movies,
      "track-by": "id",
      "label": "title",
      "placeholder": "Choose a movie",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_c('span', {
          staticClass: "loyalty-card__form-option"
        }, [_c('img', {
          staticClass: "img-responsive",
          attrs: {
            "src": props.option.poster
          }
        })]), _vm._v("\n                                            " + _vm._s(props.option.title) + "\n                                    ")])]
      }
    }]),
    model: {
      value: (_vm.selectedMovie),
      callback: function($$v) {
        _vm.selectedMovie = $$v
      },
      expression: "selectedMovie"
    }
  })]], 2)], 1)], 1)]), _vm._v(" "), (_vm.selectedMovie) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema Type")]), _vm._v(" "), _c('div', {
    staticClass: "detail-experience"
  }, [_c('sk-list', _vm._l((_vm.selectedMovie.getExperienceForCinema(_vm.cinema_id)), function(experience) {
    return _c('sk-list-tile', {
      key: experience.name,
      attrs: {
        "value": experience == _vm.selectedExperience
      },
      nativeOn: {
        "click": function($event) {
          _vm.setSelectedExperience(experience)
        }
      }
    }, [_c('span', {
      staticClass: "label label--lg"
    }, [_vm._v(_vm._s(experience))])])
  }))], 1), _vm._v(" "), _c('hr')]) : _vm._e()], 1), _vm._v(" "), (_vm.availableDates.length > 0) ? _c('div', {
    staticClass: "detail-movie-select-date"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Date and Time")]), _vm._v(" "), (_vm.availableDates.length <= 6 && !_vm.$breakpoints.xs) ? [_c('sk-layout', _vm._l((_vm.availableDates), function(session, index) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "sm2": "",
        "md2": "",
        "lg2": "",
        "grow": ""
      }
    }, [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
      staticClass: "label__month"
    }, [(_vm.$breakpoints.mdDown) ? [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_short_month) + "\n                            ")] : [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_long_month) + "\n                            ")], _vm._v("\n                            " + _vm._s(session.show_time.additional.year) + "\n                        ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session.show_time.date == _vm.selectedDate, 'btn-mask': true
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedDate(session.show_time.date);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-date--date"
    }, [_c('div', {
      staticClass: "detail-movie-select-date--day"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.day) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-date--month"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.string_short_day_of_week) + "\n                                ")])])])])
  }))] : [_c('sk-carousel', {
    attrs: {
      "slides-per-page": (_vm.$breakpoints.smDown ? 3 : 6)
    }
  }, _vm._l((_vm.availableDates), function(session, index) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
      staticClass: "label__month"
    }, [(_vm.$breakpoints.mdDown) ? [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_short_month) + "\n                            ")] : [_vm._v("\n                                " + _vm._s(session.show_time.additional.string_long_month) + "\n                            ")], _vm._v("\n                            " + _vm._s(session.show_time.additional.year) + "\n                        ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session.show_time.date == _vm.selectedDate, 'btn-mask': true
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedDate(session.show_time.date);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-date--date"
    }, [_c('div', {
      staticClass: "detail-movie-select-date--day"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.day) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-date--month"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.string_short_day_of_week) + "\n                                ")])])])])
  }))], _vm._v(" "), (_vm.selectedDate) ? _c('div', {
    staticClass: "detail-movie-select-time",
    class: (_vm.availableSessions.length >= 6) ? 'carousel' : ''
  }, [(_vm.availableSessions.length <= 6 && !_vm.$breakpoints.xs) ? [_c('sk-layout', _vm._l((_vm.availableSessions), function(session) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "grow": ""
      }
    }, [_c('span', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session == _vm.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedSession(session);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-time--time"
    }, [_vm._v("\n                                " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(_vm.getStatusString(session)))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')))])])])
  }))] : [_c('sk-carousel', {
    attrs: {
      "data": _vm.availableSessions,
      "slides-per-page": (_vm.$breakpoints.smDown ? 3 : 6)
    }
  }, _vm._l((_vm.availableSessions), function(session) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [_c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: session == _vm.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedSession(session);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-time--time"
    }, [_vm._v("\n                                    " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                    \n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(_vm.getStatusString(session)))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-time--info"
    }, [_vm._v("\n                                    " + _vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')) + "\n                                ")])])])
  }))]], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "detail__book-ticket"
  }, [(!_vm.$breakpoints.smDown) ? _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAddOrderDialog = true
      }
    }
  }, [_vm._v("Cancel\n            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    class: (!_vm.canBook ? 'btn--disabled' : ''),
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        _vm.addOrder()
      }
    }
  }, [_vm._v("\n                Add movie to booking\n            ")])], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.cancelAddOrderDialog),
      callback: function($$v) {
        _vm.cancelAddOrderDialog = $$v
      },
      expression: "cancelAddOrderDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAddOrderDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAddOrderDialog = false
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to cancel this addition to your booking? ")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAddOrderDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelAddOrder();
        _vm.cancelAddOrderDialog = false;
      }
    }
  }, [_vm._v("I'm sure")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02dc5242","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/seating/seating.vue
// module id = 727
// module chunks = 0